import { render, staticRenderFns } from "./the-add-type.vue?vue&type=template&id=780597fe&scoped=true&"
import script from "./the-add-type.vue?vue&type=script&lang=js&"
export * from "./the-add-type.vue?vue&type=script&lang=js&"
import style0 from "./the-add-type.vue?vue&type=style&index=0&id=780597fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780597fe",
  null
  
)

export default component.exports